function sanitizeDescription(raw) {
  let text = raw;
  let redacted = false;
  const mark = () => { redacted = true; };
  text = text.replace(/\b\d{3}\.\d{3}\.\d{3}-\d{2}\b/g, () => { mark(); return "[CPF removido]"; });
  text = text.replace(/\b\d{11}\b/g, () => { mark(); return "[número removido]"; });
  text = text.replace(/\b[A-Za-z]{3}-?\d[A-Za-z0-9]\d{2}\b/g, () => { mark(); return "[placa removida]"; });
  text = text.replace(/\b[A-ZÀÁÂÃÉÊÍÓÔÕÚÇ][a-zà-ÿ]{2,}(?:\s+[A-ZÀÁÂÃÉÊÍÓÔÕÚÇ][a-zà-ÿ]{2,}){1,3}\b/g, () => { mark(); return "[nome removido]"; });
  return { text, redacted };
}
window.sanitizeDescription = sanitizeDescription;

const REPORT_PRIMARY_CATS = ["roubo", "veiculo", "suspeito", "arrombamento"];
const REPORT_TIME_OPTIONS = [
  { key: "timeRightNow", offset: 0 },
  { key: "timeAgo15min", offset: 15 * 60 * 1000 },
  { key: "timeEarlierToday", offset: 6 * 60 * 60 * 1000 },
];

function ReportMiniMap({ lang, lat, lng, onPick, showToast }) {
  const mapDivRef = React.useRef(null);
  const mapRef = React.useRef(null);
  const markerRef = React.useRef(null);
  const onPickRef = React.useRef(onPick);
  onPickRef.current = onPick;
  const showToastRef = React.useRef(showToast);
  showToastRef.current = showToast;

  function locateSelf() {
    if (!navigator.geolocation) { showToastRef.current && showToastRef.current(t(lang, "locateDeniedMsg")); return; }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude } = pos.coords;
        const map = mapRef.current, marker = markerRef.current;
        if (map && marker) { marker.setLatLng([latitude, longitude]); map.setView([latitude, longitude], 16); }
        onPickRef.current(latitude, longitude);
      },
      () => { showToastRef.current && showToastRef.current(t(lang, "locateDeniedMsg")); },
      { enableHighAccuracy: true, timeout: 8000, maximumAge: 0 }
    );
  }

  React.useEffect(() => {
    if (!mapDivRef.current || mapRef.current) return;
    const map = L.map(mapDivRef.current, { zoomControl: true, scrollWheelZoom: true, touchZoom: true }).setView([lat, lng], 15);
    L.tileLayer(window.VIGI_TILE_URL, window.VIGI_TILE_OPTIONS).addTo(map);
    const icon = L.divIcon({
      className: "",
      html: '<svg width="26" height="26" viewBox="0 0 24 24" fill="var(--color-alert)" stroke="#fff" stroke-width="1.2" style="filter:drop-shadow(0 1px 2px rgba(0,0,0,.5))"><path d="M12 2c-4.4 0-8 3.4-8 7.8C4 15.8 12 22 12 22s8-6.2 8-12.2C20 5.4 16.4 2 12 2z"/></svg>',
      iconSize: [26, 26],
      iconAnchor: [13, 26],
    });
    const marker = L.marker([lat, lng], { icon, draggable: true }).addTo(map);
    marker.on("dragend", () => {
      const pos = marker.getLatLng();
      onPickRef.current(pos.lat, pos.lng);
    });
    map.on("click", (e) => {
      marker.setLatLng(e.latlng);
      onPickRef.current(e.latlng.lat, e.latlng.lng);
    });
    const LocateControl = L.Control.extend({
      options: { position: "topleft" },
      onAdd: function () {
        const container = L.DomUtil.create("div", "leaflet-bar vigi-locate-control");
        const btn = L.DomUtil.create("a", "", container);
        btn.href = "#";
        btn.title = t(lang, "useMyExactLocation");
        btn.innerHTML = '<span class="vigi-locate-icon"></span>';
        L.DomEvent.on(btn, "click", (e) => {
          L.DomEvent.preventDefault(e);
          L.DomEvent.stopPropagation(e);
          locateSelf();
        });
        return container;
      },
    });
    new LocateControl().addTo(map);
    mapRef.current = map;
    markerRef.current = marker;
    return () => { map.remove(); mapRef.current = null; };
  }, []);

  return (
    <div style={{ position: "relative" }}>
      <div ref={mapDivRef} style={{ height: 150, borderRadius: 9, overflow: "hidden", position: "relative", zIndex: 0, border: "1px solid var(--color-border)" }} />
      <div style={{ marginTop: 4, fontSize: "var(--text-xs)", color: "var(--color-text-muted)" }}>{t(lang, "dragMapHint")}</div>
    </div>
  );
}

function CategoryButton({ lang, cat, active, onClick }) {
  return (
    <button onClick={onClick} style={{
      textAlign: "center", padding: "10px 4px", borderRadius: 9, display: "flex", flexDirection: "column", alignItems: "center", gap: 5, cursor: "pointer",
      border: `${active ? 2 : 1}px solid ${active ? "var(--color-brand-primary)" : "var(--color-border)"}`,
      background: active ? "var(--color-brand-tint)" : "transparent",
    }}>
      <span style={{
        display: "inline-block", width: 17, height: 17, flexShrink: 0,
        backgroundColor: active ? "var(--color-brand-deep)" : "var(--color-text-secondary)",
        WebkitMaskImage: `url(${window.catIconUrl(cat.icon)})`, maskImage: `url(${window.catIconUrl(cat.icon)})`,
        WebkitMaskSize: "contain", maskSize: "contain",
        WebkitMaskRepeat: "no-repeat", maskRepeat: "no-repeat",
        WebkitMaskPosition: "center", maskPosition: "center",
      }} />
      <span style={{ fontSize: 10.5, lineHeight: 1.25, color: active ? "var(--color-brand-deep)" : "var(--color-text-primary)", fontWeight: active ? 600 : 400 }}>{t(lang, cat.key)}</span>
    </button>
  );
}

function ReportModal({ lang, draft, setDraft, onClose, onSubmit, showToast }) {
  const { Modal, Button, Icon } = window.VigiALDesignSystem_ff2dec;
  const [step, setStep] = React.useState(1);
  const [catExpanded, setCatExpanded] = React.useState(false);
  const [locating, setLocating] = React.useState(false);
  const [locReady, setLocReady] = React.useState(false);
  const [showDetails, setShowDetails] = React.useState(false);
  const redactTimerRef = React.useRef(null);
  const [justRedacted, setJustRedacted] = React.useState(false);
  const [showExactTime, setShowExactTime] = React.useState(false);
  const [exactTimeValue, setExactTimeValue] = React.useState(() => {
    const d = new Date();
    d.setSeconds(0, 0);
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
    return d.toISOString().slice(0, 16);
  });

  const primaryCats = window.CATS.filter((c) => REPORT_PRIMARY_CATS.includes(c.id));
  const moreCats = window.CATS.filter((c) => !REPORT_PRIMARY_CATS.includes(c.id));

  function handlePick(lat, lng) {
    setDraft((d) => ({ ...d, lat, lng }));
  }

  function handleDescChange(e) {
    const { text, redacted } = sanitizeDescription(e.target.value);
    setDraft((d) => ({ ...d, desc: text }));
    if (redacted) {
      setJustRedacted(true);
      clearTimeout(redactTimerRef.current);
      redactTimerRef.current = setTimeout(() => setJustRedacted(false), 2600);
    }
  }

  function chooseCategory(id) {
    setDraft((d) => ({ ...d, category: id }));
    setStep(2);
  }

  React.useEffect(() => {
    if (step !== 2 || locReady) return;
    if (typeof window.isSecureContext !== "undefined" && !window.isSecureContext) { setLocReady(true); return; }
    if (!navigator.geolocation) { setLocReady(true); return; }
    setLocating(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setDraft((d) => ({ ...d, lat: pos.coords.latitude, lng: pos.coords.longitude }));
        setLocating(false);
        setLocReady(true);
      },
      () => { setLocating(false); setLocReady(true); },
      { enableHighAccuracy: true, timeout: 8000, maximumAge: 60000 }
    );
  }, [step, locReady]);

  function confirmOccurredAt(occurredAt) {
    const finalDraft = { ...draft, occurredAt };
    setDraft(finalDraft);
    onSubmit(finalDraft);
  }

  function chooseTime(offset) {
    confirmOccurredAt(Date.now() - offset);
  }

  function confirmExactTime() {
    const ts = new Date(exactTimeValue).getTime();
    confirmOccurredAt(isNaN(ts) ? Date.now() : Math.min(ts, Date.now()));
  }

  const stepLabel = step === 1 ? "reportStep1of3" : step === 2 ? "reportStep2of3" : "reportStep3of3";

  return (
    <Modal title={t(lang, "reportModalTitle")} onClose={onClose} width={340}>
      <div style={{ margin: "12px 16px 0", background: "var(--color-brand-tint)", borderRadius: "var(--radius-md)", padding: "8px 10px", display: "flex", gap: 6, fontSize: "var(--text-xs)", color: "var(--color-brand-deep)" }}>
        <Icon name="shield-check" size={14} color="var(--color-brand-deep)" style={{ flexShrink: 0, marginTop: 1 }} />
        {t(lang, "anonymousNote")}
      </div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 16px 0" }}>
        {step > 1 ? (
          <button onClick={() => setStep(step - 1)} style={{ display: "flex", alignItems: "center", gap: 3, background: "transparent", border: "none", cursor: "pointer", color: "var(--color-text-secondary)", fontSize: "var(--text-xs)", padding: 0 }}>
            <Icon name="chevron-left" size={13} color="var(--color-text-secondary)" /> {t(lang, "reportBack")}
          </button>
        ) : <span />}
        <span style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", fontFamily: "var(--font-mono)" }}>{t(lang, stepLabel)}</span>
      </div>

      {step === 1 && (
        <div style={{ padding: "10px 16px 16px" }}>
          <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)", marginBottom: 8 }}>{t(lang, "occurrenceType")}</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
            {primaryCats.map((c) => (
              <CategoryButton key={c.id} lang={lang} cat={c} active={draft.category === c.id} onClick={() => chooseCategory(c.id)} />
            ))}
          </div>
          {!catExpanded ? (
            <button onClick={() => setCatExpanded(true)} style={{ marginTop: 10, background: "transparent", border: "none", cursor: "pointer", color: "var(--color-brand-primary)", fontSize: "var(--text-xs)", padding: 0, display: "flex", alignItems: "center", gap: 3 }}>
              {t(lang, "seeMoreTypes")} <Icon name="chevron-down" size={12} color="var(--color-brand-primary)" />
            </button>
          ) : (
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginTop: 10 }}>
              {moreCats.map((c) => (
                <CategoryButton key={c.id} lang={lang} cat={c} active={draft.category === c.id} onClick={() => chooseCategory(c.id)} />
              ))}
            </div>
          )}
        </div>
      )}

      {step === 2 && (
        <div style={{ padding: "10px 16px 16px" }}>
          <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)", marginBottom: 6 }}>{t(lang, "local")}</div>
          {locating && !locReady ? (
            <div style={{ height: 150, borderRadius: 9, border: "1px solid var(--color-border)", display: "flex", alignItems: "center", justifyContent: "center", gap: 6, color: "var(--color-text-muted)", fontSize: "var(--text-xs)" }}>
              <Icon name="loader-circle" size={14} color="var(--color-text-muted)" /> {t(lang, "locatingForReport")}
            </div>
          ) : (
            <ReportMiniMap lang={lang} lat={draft.lat} lng={draft.lng} onPick={handlePick} showToast={showToast} />
          )}
          <div style={{ marginTop: 8, display: "flex", gap: 6, fontSize: "var(--text-xs)", color: "var(--color-text-muted)" }}>
            <Icon name="eye-off" size={13} color="var(--color-text-muted)" style={{ flexShrink: 0, marginTop: 1 }} />
            {t(lang, "privacyAdjustHint")}
          </div>
          <div style={{ marginTop: 12 }}>
            <Button variant="primary" onClick={() => setStep(3)} style={{ width: "100%" }}>{t(lang, "confirmLocation")}</Button>
          </div>
        </div>
      )}

      {step === 3 && (
        <div style={{ padding: "10px 16px 16px" }}>
          <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)", marginBottom: 8 }}>{t(lang, "whenDidItHappen")}</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {REPORT_TIME_OPTIONS.map((opt) => (
              <button key={opt.key} onClick={() => chooseTime(opt.offset)} style={{
                textAlign: "left", padding: "12px 14px", borderRadius: 9, display: "flex", alignItems: "center", gap: 8, cursor: "pointer",
                border: "1px solid var(--color-border)", background: "transparent", fontSize: "var(--text-base)", color: "var(--color-text-primary)",
              }}>
                <Icon name="clock" size={15} color="var(--color-text-secondary)" /> {t(lang, opt.key)}
              </button>
            ))}
            {!showExactTime ? (
              <button onClick={() => setShowExactTime(true)} style={{
                textAlign: "left", padding: "12px 14px", borderRadius: 9, display: "flex", alignItems: "center", gap: 8, cursor: "pointer",
                border: "1px solid var(--color-border)", background: "transparent", fontSize: "var(--text-base)", color: "var(--color-text-primary)",
              }}>
                <Icon name="calendar-clock" size={15} color="var(--color-text-secondary)" /> {t(lang, "timeExact")}
              </button>
            ) : (
              <div style={{ padding: "12px 14px", borderRadius: 9, border: "1px solid var(--color-border)", display: "flex", flexDirection: "column", gap: 8 }}>
                <input
                  type="datetime-local"
                  value={exactTimeValue}
                  max={(() => { const d = new Date(); d.setSeconds(0, 0); d.setMinutes(d.getMinutes() - d.getTimezoneOffset()); return d.toISOString().slice(0, 16); })()}
                  onChange={(e) => setExactTimeValue(e.target.value)}
                  style={{ width: "100%", fontSize: "var(--text-sm)", padding: 8, borderRadius: 8, border: "1px solid var(--color-border)", background: "var(--color-bg)", color: "var(--color-text-primary)", fontFamily: "var(--font-body)", boxSizing: "border-box" }}
                />
                <Button variant="primary" onClick={confirmExactTime} style={{ width: "100%" }}>{t(lang, "confirmExactTime")}</Button>
              </div>
            )}
          </div>
          {!showDetails ? (
            <button onClick={() => setShowDetails(true)} style={{ marginTop: 12, background: "transparent", border: "none", cursor: "pointer", color: "var(--color-brand-primary)", fontSize: "var(--text-xs)", padding: 0 }}>
              {t(lang, "addDetailsOptional")}
            </button>
          ) : (
            <div style={{ marginTop: 12 }}>
              <textarea rows={2} maxLength={140} value={draft.desc} onChange={handleDescChange}
                placeholder={t(lang, "descPlaceholder")}
                style={{ width: "100%", resize: "none", fontSize: "var(--text-sm)", padding: 8, borderRadius: 8, border: "1px solid var(--color-border)", background: "var(--color-bg)", color: "var(--color-text-primary)", fontFamily: "var(--font-body)", boxSizing: "border-box" }} />
              <div style={{ marginTop: 4, fontSize: "var(--text-xs)", color: justRedacted ? "var(--color-alert)" : "var(--color-text-muted)", minHeight: 14 }}>
                {justRedacted ? t(lang, "justRedacted") : t(lang, "sanitizeHint")}
              </div>
            </div>
          )}
        </div>
      )}
    </Modal>
  );
}
window.ReportModal = ReportModal;
